import InsurancePanel from '../components/InsurancePanel';

export default function Insurance() {
  return (
    <div className="container py-5">
      <h1 className="h2 fw-bold mb-3">Insurance & Payment</h1>
      <InsurancePanel />
    </div>
  );
}
